"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SideNav = void 0;
const carabiners_1 = require("@clearsummit/carabiners");
const react_1 = __importDefault(require("react"));
const styles_scss_1 = __importDefault(require("./styles.scss"));
const SideNav = ({ children, className }) => (react_1.default.createElement("nav", { className: (0, carabiners_1.joinStr)(styles_scss_1.default.sidenav, className) }, children));
exports.SideNav = SideNav;
exports.SideNav.defaultProps = {
    className: undefined,
};
exports.default = exports.SideNav;
